import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=6d42ddd4"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports